type Price = {
  title: string;
  text: string[];
};

export const pricing: { [key: string]: Price[] } = {
  year4: [
    {
      title: "Standard lessons:",
      text: [
        "English as a second language",
        "Phonics",
        "Mathematics",
        "Science",
        "Global perspective",
        "Computing",
        "Wellbeing",
        "Digital Literacy",
        "Humanities",
        "Music",
        "Art & design",
        "Physical education",
        "Modern Foreign Language (Serbian)",
      ],
    },
    {
      title: "Standard offer:",
      text: [
        "3 Outside play times per day",
        "2 Dental checkups per year",
        "2 Medical checkups per year",
        "Free accident insurance",
        "Regular exams and progress reports",
        "8.00-15.30 working hours",
        "Art student club",
        "Yoga student club",
      ],
    },
    {
      title: "Optional lessons:",
      text: [
        "1 Russian language lesson per week",
        "2 Robotics classes per week",
        "2 Pottery classes per month",
      ],
    },
    {
      title: "Optional offer:",
      text: [
        "Fun and educational field trips",
        "15:30-17:00 extended stay",
      ],
    },
  ],
  year3: [
    {
      title: "Standard lessons:",
      text: [
        "Mathematics",
        "Science",
        "English as a second language",
        "Computing",
        "Global perspective",
        "Wellbeing",
        "Digital Literacy",
        "Physical Education",
        "Humanities",
        "Music",
        "Art & design",
        "Physical education",
      ],
    },
    {
      title: "Standard offer:",
      text: [
        "3 Outside play times per day",
        "2 Dental checkups per year",
        "2 Medical checkups per year",
        "Free accident insurance",
        "Regular exams and progress reports",
        "8.00-15.30 working hours",
        "Art student club",
        "Yoga student club",
      ],
    },
    {
      title: "Optional lessons:",
      text: [
        "1 Russian language lesson per week",
        "2 Robotics classes per week",
        "2 Pottery classes per month",
      ],
    },
    {
      title: "Optional offer:",
      text: [
        "Fun and educational field trips",
        "15:30-17:00 extended stay",
      ],
    },
  ],
  year2: [
    {
      title: "Standard lessons:",
      text: [
        "Mathematics",
        "Science",
        "English as a second language",
        "Computing",
        "Global perspective",
        "Wellbeing",
        "Digital Literacy",
        "Physical Education",
        "Humanities",
        "Music",
        "Art & design",
        "Physical education",
      ],
    },
    {
      title: "Standard offer:",
      text: [
        "3 Outside play times per day",
        "2 Dental checkups per year",
        "2 Medical checkups per year",
        "Free accident insurance",
        "Regular exams and progress reports",
        "8.00-15.30 working hours",
        "Art student club",
        "Yoga student club",
      ],
    },
    {
      title: "Optional lessons:",
      text: [
        "1 Russian language lesson per week",
        "2 Robotics classes per week",
        "2 Pottery classes per month",
      ],
    },
    {
      title: "Optional offer:",
      text: [
        "Fun and educational field trips",
        "15:30-17:00 extended stay",
      ],
    },
  ],
  year1: [
    {
      title: "Standard lessons per week:",
      text: [
        "Mathematics",
        "Science",
        "English as a second language",
        "Music lessons",
        "Wellbeing",
        "Digital Literacy",
        "Physical Education",
        "Phonics/handwriting",
        "Art & design",
      ],
    },
    {
      title: "Standard offer:",
      text: [
        "3 Outside play times per day",
        "2 Dental checkups per year",
        "2 Medical checkups per year",
        "Free accident insurance",
        "Regular exams and progress reports",
        "8.00-15.30 working hours",
        "Art student club",
        "Yoga student club",
      ],
    },
    {
      title: "Optional lessons:",
      text: [
        "1 Russian language lesson per week",
        "2 Robotics classes per week",
        "2 Pottery classes per month",
      ],
    },
    {
      title: "Optional offer:",
      text: [
        "Fun and educational field trips",
        "15:30-17:00 extended stay",
      ],
    },
  ],
  optional1: [
    {
      title: "Homemade meals:",
      text: [
        "🍲 Lunch: 9 EUR/day (190 EUR/month)",
        "🍲 Breakfast & lunch: 13 EUR/day (280 EUR/month)",
      ],
    },
    {
      title: "2026-2027 Extended day program (15:30-17:00):",
      text: [
        "🕔 3 days/w: 140 EUR/month",
        "🕔 4 days/w: 180 EUR/month",
        "🕔 5 days/w: 220 EUR/month",
      ],
    },
  ],
  optional2: [
    {
      title: "Homemade meals:",
      text: [
        "🍲 Lunch: 9 EUR/day (190 EUR/month)",
        "🍲 Breakfast & lunch: 13 EUR/day (280 EUR/month)",
      ],
    },
    {
      title: "2026-2027 Extended day program (15:30-17:00):",
      text: [
        "🕔 3 days/w: 140 EUR/month",
        "🕔 4 days/w: 180 EUR/month",
        "🕔 5 days/w: 220 EUR/month",
      ],
    },
  ],
};
